import {Row} from "reactstrap";
import * as React from "react";

type HeroProps = {
  pageTitle: string;
    pageStatement?: string;
    children?: React.ReactNode,
};

export const Hero: React.FunctionComponent<HeroProps> = (props): JSX.Element => {
    const {pageTitle, pageStatement, children} = props;

    // output the hero HTML markup
    return (
        <Row className="contentPageHeading">
            <div className='titleBlock container'>
                {(pageTitle && pageTitle !== "") &&
                    <h1 className="title css_heading bold">{pageTitle}</h1>
                }
                {(pageStatement && pageStatement !== "") &&
                    <h3 className="heroStatement css_heading">{pageStatement}</h3>
                }
                {(children) &&
                    <h3 className="heroStatement css_heading">{children}</h3>
                }
            </div>
        </Row>
    );
}
